import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class GetVacancies {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * GetVacancies constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Get available vacancies from API.
     *
     * @return {Array}
     */
    async handle() {
        let request = await this.apiService
            .get(ApiEndpoints['vacancies'])
            .catch(() => false);

        return request ? request.data.data : [];
    }
}
